import React from 'react';

const Footer = () => {
    return (
        <div style={{bottom:'0'}} className='footer bg-light  w-100'>
        
        <div className="container">
            <div className="row justify-content-center">
            <div className="col-auto">
                <p className="mb-0 py-2" >Dingdong Restaurant &#169;
                Copyright 2021</p>
            </div>

            </div>
        </div>
         </div>
    );
};

export default Footer;